module.exports = __webpack_public_path__ + "img/nc.9f0b4a22.svg";